import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BaseURL } from "../../Files/BaseURL";

const PayOffer = ({ setPayService }) => {
    const navigate = useNavigate();
    const [Step, setStep] = useState(1);
    const [info, setInfo] = useState({});
    const [price, setPrice] = useState(0);
    const [tax, setTax] = useState(0);
    const { recivedid } = useParams();
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState('Paypal');

    const handlePayClick = () => {
        setLoading(true);
        setStep(2);
        payPaypal()
    };

    const payPaypal = async () => {
        const authToken = localStorage.getItem("p@token");
        const res = await fetch(`${BaseURL}/api/payment/pay/pay-Paypal`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken,
            },
            body: JSON.stringify({
                recivedid: recivedid,
                type: type
            })
        });
        if (!res.ok) {
            console.error('Error processing PayPal payment:', res);
            setLoading(false);
            return;
        }
        const result = await res.json();
        if (result.redirect_url) {
            window.location.href = result.redirect_url;
        } else {
            console.error('Error processing PayPal payment:', result);
        }
    };

    // Fetch user information
    const userInfo = async () => {
        const authToken = localStorage.getItem("p@token");
        const res = await fetch(`${BaseURL}/api/payment/account/pay-info`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken,
            }
        });
        return await res.json();
    };

    // Fetch price information for given recived id
    const priceInfo = async () => {
        const authToken = localStorage.getItem("p@token");
        const res = await fetch(`${BaseURL}/api/recivedoffers/recivedoffer/${recivedid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken,
            }
        });
        return await res.json();
    };

    // Fetch tax information
    const TaxInfo = async () => {
        const authToken = localStorage.getItem("p@token");
        const res = await fetch(`${BaseURL}/api/payment/tax-info`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken,
            }
        });
        const result = await res.json();
        const feePercentage = result.FeePercen;
        const resultPrice = price * feePercentage / 100;
        const cents = (result.Cent) / 100;
        return (resultPrice + cents).toFixed(2); //up to 2 decimals
    };

    // Fetch information on component mount
    useEffect(() => {
        const fetchInfo = async () => {
            const res = await userInfo();
            setInfo(res);
            const price = await priceInfo();
            setPrice(price.offer.Price);
        };
        fetchInfo();
    }, [recivedid]);

    // Fetch tax information on price change
    useEffect(() => {
        const fetchTax = async () => {
            const tax = await TaxInfo();
            setTax(tax);
        };
        fetchTax();
    }, [price]);

    return (
        <div className={`top-0 left-0 w-[100vw] h-[100vh] fixed z-[99999999999999] font-pop `}>
            <div className="absolute bg-black/50 block w-[100vw] h-[100vh] z-30" onClick={() => { setPayService(false) }}></div>
            {Step === 2 ?
                <div
                    className='py-4 px-6 bg-white max-h-[70vh] w-[90%] md:w-[50%] xl:w-[30%] mt-16 h-fit rounded-xl relative z-40 m-auto'>
                    <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">Pay offer</h2>

                    <p className="text-gray-600 mb-6 text-sm md:text-base max-w-sm">
                        {type === 'card' ? `Card account > ${info.AttachedCard.Name}` : `PayPal account > ${info.AttachedPaypal.Name}`}
                    </p>

                    <div className="flex flex-col items-center font-pop gap-1 my-6">
                        <h2 className='text-2xl font-bold'>{price} USD</h2>
                        <p className='text-sm font-normal text-lightGrey'>tax {tax} USD</p>
                    </div>
                    <button
                        className="my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-base md:text-lg py-1 md:py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp"
                        onClick={handlePayClick}
                        disabled={loading}
                    >
                        {loading ? 'Loading...' : 'Pay'}
                    </button>
                    <button
                        className='py-2 px-4 rounded-full text-center w-full font-pop text-base border-2 my-4 border-lightGrey'
                        onClick={() => {
                            setPayService(false)
                        }}
                    >
                        Cancel
                    </button>
                </div>
                :
                <div className='py-4 px-6 bg-white w-fit max-h-[70vh] mt-16 h-fit rounded-xl relative z-40 m-auto'>
                    <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">Pay offer</h2>
                    <p className="text-gray-600 mb-6 text-sm md:text-base max-w-sm">Choose your payment method</p>
                    <div className="flex flex-col font-pop gap-4">
                        {info.AttachedPaypal && (
                            <div className="flex flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer" onClick={() => { setStep(2) }}>
                                <img src="../../../../Assets/Accounts/Paypal.png" alt="" className='w-6 md:w-8 h-6 md:h-8' />
                                <p className='text-base md:text-lg font-medium'>
                                    PayPal account ({info.AttachedPaypal.Email.substring(0, 4)} ****)
                                </p>
                            </div>
                        )}
                        {info.AttachedCard && (
                            <div className="flex flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer" onClick={() => { setStep(2); setType('card') }}>
                                <img src="../../../../Assets/Accounts/card.png" alt="" className='w-6 md:w-8 h-6 md:h-8' />
                                <p className='text-base md:text-lg font-medium'>Credit card (**** {info.AttachedCard.LastDigits})</p>
                            </div>
                        )}
                    </div>
                    <button
                        className='py-2 px-4 rounded-full text-center w-full font-pop text-base border-2 my-4 border-lightGrey'
                        onClick={() => { setPayService(false); }}
                    >
                        Cancel
                    </button>
                </div>}
        </div>
    );
};

export default PayOffer;
